import * as THREE from 'three';

class GalleryApp {
  private scene: THREE.Scene;
  private camera: THREE.PerspectiveCamera;
  private renderer: THREE.WebGLRenderer;
  private canvas: HTMLCanvasElement;
  private stars: THREE.Points | undefined;
  private currentYear: number = 2026;

  constructor() {
    this.canvas = document.querySelector('#webgl-canvas') as HTMLCanvasElement;
    this.scene = new THREE.Scene();
    this.camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
    
    this.renderer = new THREE.WebGLRenderer({
      canvas: this.canvas,
      antialias: true,
      alpha: true
    });

    this.init();
  }

  private init() {
    this.renderer.setSize(window.innerWidth, window.innerHeight);
    this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

    this.camera.position.z = 50;

    // Subtle starfield background
    this.createStars();
    this.animate();

    window.addEventListener('resize', () => this.onResize());
    
    // Listen for custom year-change event from index.11ty.ts script
    window.addEventListener('year-change', (e: any) => {
        this.updateYear(e.detail.year);
    });

    // Handle search filtering
    window.addEventListener('search-query', (e: any) => {
        this.filterAlbums(e.detail.query);
    });

    // Prevent right-click on drawing images
    window.addEventListener('contextmenu', (e) => {
      const target = e.target as HTMLElement;
      if (target.tagName === 'IMG') {
        e.preventDefault();
      }
    }, false);
  }

  private createStars() {
    const starGeometry = new THREE.BufferGeometry();
    const starMaterial = new THREE.PointsMaterial({ color: 0xffffff, size: 0.1, transparent: true, opacity: 0.5 });
    const starVertices = [];
    for (let i = 0; i < 3000; i++) {
      const x = (Math.random() - 0.5) * 400;
      const y = (Math.random() - 0.5) * 400;
      const z = (Math.random() - 0.5) * 600;
      starVertices.push(x, y, z);
    }
    starGeometry.setAttribute('position', new THREE.Float32BufferAttribute(starVertices, 3));
    this.stars = new THREE.Points(starGeometry, starMaterial);
    this.scene.add(this.stars);
  }

  private onResize() {
    this.camera.aspect = window.innerWidth / window.innerHeight;
    this.camera.updateProjectionMatrix();
    this.renderer.setSize(window.innerWidth, window.innerHeight);
  }

  private updateYear(year: number) {
    const oldYear = this.currentYear;
    this.currentYear = year;

    const allContainers = document.querySelectorAll('.year-container');
    allContainers.forEach(container => {
        const cYear = parseInt(container.id.replace('year-', ''));
        container.classList.remove('active', 'past', 'future');
        
        if (cYear === year) {
            container.classList.add('active');
        } else if (cYear < year) {
            container.classList.add('past');
        } else {
            container.classList.add('future');
        }
    });
  }

  private filterAlbums(query: string) {
    const albums = document.querySelectorAll('.album-card');
    const drawingsData = JSON.parse(document.getElementById('drawings-data').textContent);

    albums.forEach(albumEl => {
        const albumName = albumEl.querySelector('.album-title').textContent;
        const albumDrawings = drawingsData.filter((d: { group: string; }) => d.group === albumName);
        
        const matches = albumName.toLowerCase().includes(query) || 
                        albumDrawings.some((d: { title: string; tags: any[]; }) => 
                            d.title.toLowerCase().includes(query) || 
                            d.tags.some(t => t.toLowerCase().includes(query))
                        );
        
        (albumEl as HTMLElement).style.display = matches ? 'block' : 'none';
    });
  }

  private animate() {
    requestAnimationFrame(() => this.animate());

    // Slow rotation of stars
    if (this.stars) {
        this.stars.rotation.y += 0.0005;
        this.stars.rotation.x += 0.0002;
    }

    this.renderer.render(this.scene, this.camera);
  }
}

window.addEventListener('DOMContentLoaded', () => {
  new GalleryApp();
});